import Axios from "../config/config";

//Quiz Ans Details

export const QUIZ_ANSWER_DETAILS= async (body) => {
    try {
        const response = await Axios.post('quiz-answer-details/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};